"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const Slide_vue_1 = tslib_1.__importDefault(require("../Slide.vue"));
exports.default = vue_1.default.extend({
    name: 'push-notification',
    props: {},
    computed: {},
    methods: {},
    components: {
        IsotopeSlide: Slide_vue_1.default,
    },
});
